import React, { useState, useEffect } from "react";
import CarFooter from "../components/CarFooter";
import CarFooterbar from "../components/CarFooterbar";
import axios from "axios";
import "../styles/variables.css";
import "../styles/TextStyle.css";
import Section1 from "../sections/Section1";
import Section8 from "../sections/Section8";
import Section9 from "../sections/Section9";
import Section10 from "../sections/Section10";
const InsegneMappa = () => {
  const [sectionsData, setSectionsData] = useState([]);
  const apiEndpointInsegneMappa = `https://gestione.carellidistribuzione.it/react-endpoint-api/get-data-page/insegne-mappa?${new Date().getTime()}`;
  const apiEndpointPVList = `https://gestione.carellidistribuzione.it/react-endpoint-api/pv-list?${new Date().getTime()}`;
  const [selectedCity] = useState("BARI"); // default

    const [showLoader, setShowLoader] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    




  useEffect(() => {
    const fetchData = async () => {
      try {

        const [resIM, pvListRes] = await Promise.all([
          axios.get(apiEndpointInsegneMappa), // Insegne-mappa
          axios.get(apiEndpointPVList), // Punti vendita
        ]);

        const rdIM = resIM.data;
        const rdPVData = pvListRes.data.data;
        // Formatta i dati di pvList
        const formattedPvList = Object.keys(rdPVData).map((key) => {
          const pv = rdPVData[key];
          return {
            name: pv.name,
            city: pv.city,
            postalCode: pv.postalCode,
            address: pv.address,
            orari: pv.orari,
            codice: pv.codice,
            position: {
              lat: parseFloat(pv.position.lat),
              lng: parseFloat(pv.position.lng),
            },
          };
        });

        // const defaultPvList = formattedPvList.filter(
        //   (pv) => pv.city?.toUpperCase() === selectedCity
        // );
        const defaultPvList = formattedPvList;

          

        const newSectionsData = [
          {
            section: 1,
            breadCrumbs: rdIM.data?.["insegne-mappa"]?.["316"]?.breadcrumbs,

            contenuti: [368].map((id) => {
              const contenuto =
                rdIM.data?.["insegne-mappa"]?.["316"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_it,
                immagineBg: contenuto?.immagine_url,
                descrizione_it: contenuto?.descrizione_it,
              };
            }),
          },
          {
            section: 8,
            contenuti: [369].map((id) => {
              const contenuto =
                rdIM.data?.["insegne-mappa"]?.["317"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                descrizione: contenuto?.descrizione_it,
                immaginiAggiuntive: contenuto?.immagini_aggiuntive,
              };
            }),
            callToActions: [
              {
                callToAction1:
                  rdIM.data?.["insegne-mappa"]?.["317"]?.contenuti?.["370"]
                    ?.call_to_action_it,
                link1:
                  rdIM.data?.["insegne-mappa"]?.["317"]?.contenuti?.["370"]
                    ?.link_it,
              },
              {
                callToAction2:
                  rdIM.data?.["insegne-mappa"]?.["317"]?.contenuti?.["371"]
                    ?.call_to_action_it,
                link2:
                  rdIM.data?.["insegne-mappa"]?.["317"]?.contenuti?.["371"]
                    ?.link_it,
              },
            ],
          },

          {
            section: 9,
            immagineBg:
              rdIM.data?.["insegne-mappa"]?.["318"]?.contenuti?.["376"]
                ?.immagine_url,
            contenuti: [372, 373, 374, 375].map((id) => {
              const contenuto =
                rdIM.data?.["insegne-mappa"]?.["318"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_it,
                sottotitolo: contenuto?.sottotitolo_it,
                descrizione: contenuto?.descrizione_it,
                immagine: contenuto?.immagine_url,
                link: contenuto?.link_it,
                callToAction: contenuto?.call_to_action_it,
              };
            }),
          },
          {
            section: 10,
            pvList: defaultPvList,
            contenuti: [378].map((id) => {
              const contenuto =
                rdIM.data?.["insegne-mappa"]?.["321"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                descrizione: contenuto?.descrizione_it,
              };
            }),
          },

          {
            section: 99
          }
        ];

        setSectionsData(newSectionsData);
      } catch (error) {
        console.error("Errore durante il caricamento dei dati:", error);
      }
    };

        const scrollToAnchor = () => {
      const { hash } = window.location;
      if (hash) {
        // rimuove il “#”
        const id = hash.slice(1);
        const el = document.getElementById(id);
        if (el) {
          // scroll “smooth” (o behavior: 'auto' se preferisci)
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };

    // piccola attesa per assicurarsi che il DOM sia renderizzato
    setTimeout(scrollToAnchor, 100);

    fetchData();
  }, [selectedCity]);

    useEffect(() => {
        if (sectionsData.length > 0) {
          setFadeOut(true);
          const timer = setTimeout(() => {
            setShowLoader(false);
            const footerElem = document.querySelector("footer");
            if (footerElem) {
              footerElem.classList.remove("d-none");
            }
          }, 500); 
          return () => clearTimeout(timer);
        }else{
          const f = document.querySelector('footer');
        if (f) f.classList.add('d-none');
        }
      }, [sectionsData]);


  return (
    <>
         {showLoader && (
        <div className={`layout-loader${fadeOut ? " fade-out" : ""}`}>
          <span className="loader" />
        </div>
      )}
      {sectionsData.map((section, index) => {
        switch (section.section) {
          case 1:
            return (
              <Section1
                key={index}
                breadCrumbs={section.breadCrumbs}
                contenuti={section.contenuti}
              />
            );
          case 8:
            return (
              <Section8
                key={index}
                contenuti={section.contenuti}
                callToAction1={section.callToActions[0]?.callToAction1}
                link1={section.callToActions[0]?.link1}
                callToAction2={section.callToActions[1]?.callToAction2}
                link2={section.callToActions[1]?.link2}
              />
            );

          case 9:
            return (
              <Section9
                key={index}
                contenuti={section.contenuti}
                immagineBg={section.immagineBg}
              />
            );
          case 10:
            return (
              <Section10
                key={index}
                pvList={section.pvList}
                contenuti={section.contenuti}
              />
            );
          default:
            return null;
        }
      })}

    </>
  );
};

export default InsegneMappa;
